export default {
  submitText: '保存',
  emptyBtn: false,

  column: [
    {
      label: '上级节点',
      prop: 'parentId',
      display: true,
      formslot: true,
      rules: [
        {
          required: true,
          message: '请选择上级节点',
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '上级属性',
      prop: 'parentParkTypeName',
      display: true,
      readonly: true,
      span: 12,
    },
    {
      label: '车位编号',
      prop: 'parkSpaceNo',
      display: true,
      rules: [
        {
          required: true,
          message: '请输入车位编号',
          trigger: 'change',
        },
      ],
      span: 12,
    },
    {
      label: '车位状态',
      prop: 'carParkStatus',
      formslot: true,
      display: true,
      span: 12,
      rules: [
        {
          required: true,
          message: '请选择车位状态',
          trigger: 'change',
        },
      ],
    },
  ],
};
